import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';

const SepaSummary = ({ info  })=>{
    const { getLabel  } = useIntl();
    if (!info || !('iban' in info) || typeof info.iban !== 'string') {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "checkout-payment-info__label"
    }, getLabel('ibanNumber')), /*#__PURE__*/ React.createElement("div", {
        className: "checkout-payment-info__value"
    }, info.iban));
};

export { SepaSummary };
//# sourceMappingURL=SepaSummary.js.map
